module.exports = __webpack_public_path__ + "static/media/answer-wrong.40c335dd.ogg";